import React, { useEffect, useState } from "react";
import { Space, List, Button, Col, Row, Table, Popconfirm, Typography } from "antd";
import { useNavigate } from "react-router";
import ProductOptionService from "services/product_option";
import { useApp } from "../../contexts/app";
const { Text } = Typography;
const service = new ProductOptionService();

const ProductOption = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [listDetail, setDetail] = useState([]);
  const [curSelected, setcurSelected] = useState();
  const { prompt } = useApp();
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    var list = await service.list();
    setData(list);
  };

  useEffect(() => {
    var item = data.find(x => x.id == curSelected?.id);
    if (item) {
      setDetail(item.values);
    } else {
      setDetail([])
    }
  }, [data, curSelected])

  const handleClickProductOption = (item) => {

    setDetail(item.values);
    setcurSelected(item);
  };

  const handleDelete = async (parentid, id) => {

    await service.deleteValue({ id: id, parent_id: parentid });
    loadData();
  };

  const handlDeleteParent = async (id) => {

    await service.delete(id);
    setcurSelected(undefined);
    loadData();
    setDetail([]);
  }

  const addNew = () => {
    prompt({
      title: "Thêm mới thuộc tính", label: "Nhập Tên",
      onOk: async (text) => {
        const service = new ProductOptionService();

        await service.create({ title: text });
        loadData();
      }
    });
  }


  const editOption = (option) => {
    prompt({
      title: "Sửa thuộc tính", label: "Nhập Tên", value: option.title,
      onOk: async (text) => {
        const service = new ProductOptionService();

        await service.update({ title: text, id: option.id });
        loadData();
      }
    });
  }


  const addNewValue = () => {
    prompt({
      title: "Thêm mới giá trị", label: "Nhập Tên",
      onOk: async (text) => {
        const service = new ProductOptionService();
        await service.createValue({ title: text, parent_id: curSelected.id });
        loadData();

      }
    });
  }






  const editValue = (item) => {

    prompt({
      title: "Sửa giá trị", label: "Nhập Tên", value: item.title,
      onOk: async (text) => {
        const service = new ProductOptionService();

        await service.updateValue({ title: text, id: item.id, parent_id: curSelected.id });
        loadData();

      }
    });
  }

  // const data = [
  //   {
  //     key: '1',
  //     name: 'John Brown',
  //     age: 32,
  //     address: 'New York No. 1 Lake Park',
  //     tags: ['nice', 'developer'],
  //   },
  //   {
  //     key: '2',
  //     name: 'Jim Green',
  //     age: 42,
  //     address: 'London No. 1 Lake Park',
  //     tags: ['loser'],
  //   },
  //   {
  //     key: '3',
  //     name: 'Joe Black',
  //     age: 32,
  //     address: 'Sydney No. 1 Lake Park',
  //     tags: ['cool', 'teacher'],
  //   },
  // ];

  const columns = [

    {
      title: "Phân loại",
      dataIndex: "title",
      key: "title",
    },
    {
      title: (
        <div>
          <Button onClick={addNewValue}>
            Thêm mới
          </Button>
        </div>
      ),
      key: "action",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={(e) => {
              editValue(record)
            }

            }
          >
            Chỉnh sửa
          </Button>
          <Popconfirm
            title="Xóa thuộc tính"
            description="Bạn có muốn xóa thuộc tính này ?"
            okText="Có"
            cancelText="Không"
            onConfirm={() => handleDelete(curSelected.id, record.id)}
          >
            <Button color="danger" variant="link">
              Xóa
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Row gutter={16}>
        <Col
          span={8}
          style={{
            borderRight: "1px solid rgb(240, 240, 240)",
            paddingRight: "8px",
          }}
        >
          <Button
            style={{
              width: "100%",
            }}
            onClick={addNew}
          >
            Thêm mới
          </Button>
          <List
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item, index) => (
              <List.Item
                className="hover-item"
                // actions={[
                //   <a key="list-loadmore-edit">Edit</a>,
                //   <a key="list-loadmore-more">Delete</a>,
                // ]}
                style={{
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f5f5f5")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                onClick={() => handleClickProductOption(item)}
                actions={[
                  <Button
                    type="link"
                    onClick={(e) =>
                      editOption(item)
                    }
                  >
                    Chỉnh sửa
                  </Button>,
                  <Popconfirm
                    title="Xóa thuộc tính con"
                    description="Bạn có muốn xóa thuộc tính này ?"
                    okText="Có"
                    cancelText="Không"
                    onConfirm={() => handlDeleteParent(item.id)}
                  >
                    <Button color="danger" variant="link">
                      Xóa
                    </Button>
                  </Popconfirm>

                ]}
              >
                <List.Item.Meta
                  title={<a href="#">{item.title}</a>}
                  description={item.id}

                />
              </List.Item>
            )}
          />
        </Col>
        <Col span={16}>
          <Text strong>{curSelected === undefined ? "" : curSelected.title}</Text>

          <Table columns={columns} dataSource={listDetail} />
        </Col>
      </Row>
    </>
  );
};
export default ProductOption;
